import React from 'react';
import { FormDialog } from '@marageti/z4-lib';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { Box, Typography } from '@mui/material';
import TravelerForm from '../traveler-create-account-form/traveler-form';

const CreateTravelerModal = ({
  open,
  onCancel,
  handleSubmit,
  submissionError,
}:{
  open:boolean
  onCancel:() => void
  handleSubmit: (data: any) => void
  submissionError: ApiError | undefined
}) => (
  <FormDialog
    open={open}
    large
  >
    <Box
      sx={{ padding: 4 }}
    >
      <Typography variant="h6">New Traveler Account</Typography>
      <TravelerForm
        onCancel={onCancel}
        onSubmit={handleSubmit}
        submissionError={submissionError}
      />
    </Box>
  </FormDialog>
);

export default CreateTravelerModal;
